import React, { useEffect } from "react";
import "./Ordered.css";
import { useDispatch, useSelector } from "react-redux";
import Ordered_Card from "../../../common-components/ordered_card/Ordered_Card";
import { getAllOrder } from "../../../../features/order/orderSlice";
import { encodeId, OrderStatusIds } from "../../../../utils/common";

const Ordered = ({ type, onOpenOrderDetails }) => {
  const dispatch = useDispatch();
  const allOrders = useSelector((state) => state.order.allOrders);
  const statusIds = [
    OrderStatusIds.Pending,
    OrderStatusIds.Processing,
    OrderStatusIds.Preparing,
    OrderStatusIds.OrderUnderQualityCheck,
    OrderStatusIds.Pickup,
  ];

  const fetch = async (page = 1) => {
    await dispatch(getAllOrder({ order_status_id: statusIds }));
  };

  useEffect(() => {
    fetch();
  }, [dispatch, type]);

  const handlePageChange = (page) => {
    fetch(page);
  };

  return (
    <section className="Ordered">
      {/* Desktop View */}
      <div className="order_table table-responsive">
        <div className="row table_row w-100">
          <div className="col-md-3">
            <p className="table_head product_head">Order</p>
          </div>

          <div className="col-md-2 ">
            <p className="table_head">Status</p>
          </div>

          <div className="col-md-2">
            <p className="table_head">Price</p>
          </div>

          <div className="col-md-2">
            <p className="table_head">Est date</p>
          </div>

          <div className="col-md-2 ">
            {/* <p className="table_head action_head ">Action</p> */}
          </div>
        </div>
      </div>

      <div className="all_cards_holder">
        {allOrders?.data?.map((item) => {
          return (
            <Ordered_Card
              data={item}
              showTrackOrder={true}
              track_order_text="Track Now"
              baseLike={`/order-details/${encodeId(item?.id)}`}
              type={type}
              onOpenOrderDetails={onOpenOrderDetails}
            />
          );
        })}
      </div>

      <div className="no_data_main_div">
        <p className="no_data_text">No more orders to show</p>
      </div>
    </section>
  );
};

export default Ordered;
